import { AnalyticsProvider } from './analytics';
import QueryProvider from './query';
import { ArcadeStoreProvider } from './store';
import TRPCProvider from './trpc';
import { PuzzleWalletProvider } from '@puzzlehq/sdk';

const RootProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <PuzzleWalletProvider>
      <TRPCProvider>
        <QueryProvider>
          <ArcadeStoreProvider>
            <AnalyticsProvider
              writeKey={import.meta.env.VITE_SEGMENT_WRITE_KEY!}
            >
              {children}
            </AnalyticsProvider>
          </ArcadeStoreProvider>
        </QueryProvider>
      </TRPCProvider>
    </PuzzleWalletProvider>
  );
};

export default RootProvider;
